import './App.css';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { useState } from 'react';
import { ConfigProvider, Divider, Grid, Layout, theme } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import Logo from "./images/logo.png";
import Logodark from "./images/logodark.png";
import Logo1 from "./images/logolong.png";
import Logo1dark from "./images/logolongdark.png";
import Sidebar from './screens/global/Sidebar';
import Topbar from './screens/global/Topbar';
import { setDarkmode } from './slices/darkmodeSlice';
const { Content, Footer, Sider } = Layout;

function App() {
  const { darkAlgorithm, compactAlgorithm } = theme;
  const { userInfo } = useSelector((state) => state.auth);
  const { darkmode } = useSelector((state) => state.darkmode);
  const dispatch = useDispatch();

  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const [collapsed, setCollapsed] = useState(false);
  
  const onCollapse = () => {
    setCollapsed(!collapsed);
  };

  const isCompactMode = false;

  const toggleDarkMode = () => {
    dispatch(setDarkmode(darkmode ? false : true));
  };

  return (
    <>
    <ConfigProvider 
    theme={{
        components: {
          Table: {
            headerBg: "#2f3640",
            headerColor: "whitesmoke"
          },
               
                  },
        algorithm: darkmode
      ? (isCompactMode ? [darkAlgorithm, compactAlgorithm] : [darkAlgorithm])
      : (isCompactMode ? [compactAlgorithm] : undefined),
      }} >

    
    {userInfo ? (
      <Layout style={{ minHeight: '100vh' }}>
        <Sider  collapsed={collapsed} onCollapse={onCollapse} className='sidebar' theme='light' breakpoint="lg" width={200} style={{boxShadow: "0px 3px 6px 0px rgba(0, 0, 0, 0.12)"}}>
          {(collapsed) && (
            darkmode ? <img src={Logodark} height={"25px"} style={{margin: "16px", marginLeft: "30px"}}/> : <img src={Logo} height={"25px"} style={{margin: "16px", marginLeft: "30px"}} alt='logo'/>
          )}
          {(!collapsed) && (
            
            darkmode ? <img src={Logo1dark} height={"25px"} style={{margin: "16px", marginLeft: "30px"}}/> :  <img src={Logo1} height={"25px"} style={{margin: "16px", marginLeft: "30px"}} alt='logodark'/>
          )}
          <Sidebar/>
        </Sider>
            <Layout className="site-layout">
              <Topbar isDarkMode={darkmode} toggleDarkMode={toggleDarkMode} setCollapsed={setCollapsed} collapsed={collapsed} screens={screens} />
              <Content className={`content-wrapper ${collapsed || screens.lg ? '' : 'blurred'} `} style={{ margin: '20px' }}>
                <Outlet/>
              </Content>
              <Divider/>
              <Footer style={{ textAlign: 'center' }}>Lincfolio © {new Date().getFullYear()} </Footer>
            </Layout>
      </Layout>
    ): (
      <Outlet />
    )}
    </ConfigProvider>
    </>
  );
}


export default App;
